"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decompressWithPreamble = exports.parseCompressedPreamble = exports.decompressAuto = exports.compressAuto = exports.decompressAfterDecryption = exports.compressForEncryption = void 0;
var encoders_1 = require("./encoders");
var OBFUSCATE_BYTES = 16;
var MASK_MULTIPLIER = 31;
var MAX_SEED = 256;
function readStream(reader) {
    return __awaiter(this, void 0, void 0, function () {
        var chunks, _a, value, done, total, result, offset, _i, chunks_1, chunk;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    chunks = [];
                    _b.label = 1;
                case 1:
                    if (!true) return [3 /*break*/, 3];
                    return [4 /*yield*/, reader.read()];
                case 2:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (done)
                        return [3 /*break*/, 3];
                    if (value)
                        chunks.push(value);
                    return [3 /*break*/, 1];
                case 3:
                    total = chunks.reduce(function (sum, chunk) { return sum + chunk.length; }, 0);
                    result = new Uint8Array(total);
                    offset = 0;
                    for (_i = 0, chunks_1 = chunks; _i < chunks_1.length; _i++) {
                        chunk = chunks_1[_i];
                        result.set(chunk, offset);
                        offset += chunk.length;
                    }
                    return [2 /*return*/, result];
            }
        });
    });
}
function obfuscate(data) {
    if (data.length === 0)
        return data;
    var seed = Math.floor(Math.random() * MAX_SEED);
    var out = new Uint8Array(data);
    var limit = Math.min(OBFUSCATE_BYTES, out.length);
    for (var i = 0; i < limit; i++) {
        var mask = (seed + i * MASK_MULTIPLIER) & 0xFF;
        out[i] ^= mask;
    }
    var result = new Uint8Array(out.length + 1);
    result.set(out);
    result[out.length] = seed;
    return result;
}
function deobfuscate(data) {
    if (data.length < 2)
        return null;
    var seed = data[data.length - 1];
    var obfuscated = data.slice(0, -1);
    var deobfuscated = new Uint8Array(obfuscated);
    var limit = Math.min(OBFUSCATE_BYTES, deobfuscated.length);
    for (var i = 0; i < limit; i++) {
        var mask = (seed + i * MASK_MULTIPLIER) & 0xFF;
        deobfuscated[i] ^= mask;
    }
    return deobfuscated;
}
function compressGzip(text) {
    return __awaiter(this, void 0, void 0, function () {
        var stream, writer, data, buffer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stream = new CompressionStream('gzip');
                    writer = stream.writable.getWriter();
                    writer.write(new TextEncoder().encode(text));
                    writer.close();
                    return [4 /*yield*/, readStream(stream.readable.getReader())];
                case 1:
                    data = _a.sent();
                    buffer = new ArrayBuffer(data.length);
                    new Uint8Array(buffer).set(data);
                    return [2 /*return*/, buffer];
            }
        });
    });
}
function decompressGzip(data) {
    return __awaiter(this, void 0, void 0, function () {
        var stream, writer, arrayBuffer, decompressed;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stream = new DecompressionStream('gzip');
                    writer = stream.writable.getWriter();
                    arrayBuffer = data instanceof ArrayBuffer ? data : new ArrayBuffer(data.byteLength);
                    if (!(data instanceof ArrayBuffer)) {
                        new Uint8Array(arrayBuffer).set(new Uint8Array(data));
                    }
                    writer.write(new Uint8Array(arrayBuffer));
                    writer.close();
                    return [4 /*yield*/, readStream(stream.readable.getReader())];
                case 1:
                    decompressed = _a.sent();
                    return [2 /*return*/, new TextDecoder().decode(decompressed)];
            }
        });
    });
}
function compressForEncryption(text, mode, encoder) {
    if (encoder === void 0) { encoder = encoders_1.defaultEncoder; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, compressed;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = mode;
                    switch (_a) {
                        case 'gzip': return [3 /*break*/, 1];
                        case 'none': return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, compressGzip(text)];
                case 2:
                    compressed = _b.sent();
                    return [2 /*return*/, encoder.encode(compressed)];
                case 3: return [2 /*return*/, text];
            }
        });
    });
}
exports.compressForEncryption = compressForEncryption;
function decompressAfterDecryption(encoded, encoders) {
    if (encoders === void 0) { encoders = [encoders_1.defaultEncoder, new encoders_1.Base64Encoder()]; }
    return __awaiter(this, void 0, void 0, function () {
        var buffer, data, deobfuscated, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    try {
                        buffer = (0, encoders_1.decodeWithFallbacks)(encoded, encoders);
                    }
                    catch (_d) {
                        return [2 /*return*/, encoded];
                    }
                    if (buffer.byteLength === 0)
                        return [2 /*return*/, encoded];
                    data = new Uint8Array(buffer);
                    deobfuscated = deobfuscate(data);
                    if (!deobfuscated) return [3 /*break*/, 4];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, decompressGzip(deobfuscated.buffer)];
                case 2: return [2 /*return*/, _c.sent()];
                case 3:
                    _a = _c.sent();
                    return [3 /*break*/, 4];
                case 4:
                    _c.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, decompressGzip(buffer)];
                case 5: return [2 /*return*/, _c.sent()];
                case 6:
                    _b = _c.sent();
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/, encoded];
            }
        });
    });
}
exports.decompressAfterDecryption = decompressAfterDecryption;
function compressAuto(text, encoder, preamble) {
    if (encoder === void 0) { encoder = encoders_1.defaultEncoder; }
    return __awaiter(this, void 0, void 0, function () {
        var compressed, obfuscated, encoded, finalOutput;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, compressGzip(text)];
                case 1:
                    compressed = _a.sent();
                    obfuscated = obfuscate(new Uint8Array(compressed));
                    encoded = encoder.encode(obfuscated.buffer);
                    finalOutput = preamble ? "s1 > ".concat(preamble, " > ").concat(encoded) : encoded;
                    return [2 /*return*/, { mode: 'gzip', output: finalOutput }];
            }
        });
    });
}
exports.compressAuto = compressAuto;
function decompressAuto(input, encoders) {
    if (encoders === void 0) { encoders = [encoders_1.defaultEncoder, new encoders_1.Base64Encoder()]; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, decompressAfterDecryption(input, encoders)];
        });
    });
}
exports.decompressAuto = decompressAuto;
function parseCompressedPreamble(input) {
    if (!input) {
        return null;
    }
    // Split on " > " and validate exactly 3 parts
    var parts = input.split(' > ');
    if (parts.length !== 3 || parts[0] !== 's1') {
        return null;
    }
    var prefix = parts[0], preamble = parts[1], compressedData = parts[2];
    if (!preamble.trim() || !compressedData.trim()) {
        return null;
    }
    return {
        preamble: preamble.trim(),
        compressedData: compressedData.trim()
    };
}
exports.parseCompressedPreamble = parseCompressedPreamble;
function decompressWithPreamble(input, encoders) {
    if (encoders === void 0) { encoders = [encoders_1.defaultEncoder, new encoders_1.Base64Encoder()]; }
    return __awaiter(this, void 0, void 0, function () {
        var parsed, decompressed, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    parsed = parseCompressedPreamble(input);
                    if (!parsed) {
                        return [2 /*return*/, null];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, decompressAfterDecryption(parsed.compressedData, encoders)];
                case 2:
                    decompressed = _b.sent();
                    return [2 /*return*/, {
                            preamble: parsed.preamble,
                            decompressed: decompressed
                        }];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.decompressWithPreamble = decompressWithPreamble;
